import { colours } from "../../_styleguide/_colours";
var ChartEndLabel = /** @class */ (function () {
    function ChartEndLabel(ctrlr, yParameter, label, colour) {
        this.ctrlr = ctrlr;
        this.yParameter = yParameter;
        this.label = label;
        this.colour = colour;
    }
    ChartEndLabel.prototype.draw = function () {
        this.ctrlr.svg.layers.data.selectAll('.label_group.' + this.yParameter).remove();
        this.labelGroup = this.ctrlr.svg.layers.data
            .append('g')
            .attr('class', 'label_group ' + this.yParameter);
        // this.labelGroup
        //     .append('rect')
        //     .attr('y',-8)
        //     .attr('width',((this.label.length + 3) * 5))
        //     .attr('height',16)
        //     .style('fill',colours[this.colour][0])
        this.labelGroup
            .append('text')
            .text(this.label)
            .attr('dx', 4)
            .attr('dy', 4)
            .style('font-size', '.66rem')
            .attr('fill', colours[this.colour][0])
            .style('text-transform', 'lowercase');
    };
    ChartEndLabel.prototype.redraw = function (data) {
        this.labelGroup
            .attr("transform", "translate(" + this.ctrlr.dimensions.width + "," + this.ctrlr.scales.y.scale(data[this.yParameter]) + ")");
    };
    return ChartEndLabel;
}());
export { ChartEndLabel };
